import { useIsMobile } from "@/hooks/use-mobile";
import { RootState } from "@/redux/store";
import { getOwnerBomBase, routes } from "@/routes/utils";
import moment from "moment";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const useAR360Report = () => {
  const fromDashboard = useLocation().pathname?.includes("/dashboard");
  const base = getOwnerBomBase(useLocation().pathname);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [isPropertyView, setIsPropertyView] = useState<boolean>(false);
  const [date, setDate] = useState<any>(moment());

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  
  const {currentFinanceYear, currentRole} = useSelector(
    (state: RootState) => state.currentData
  );
  
  const breadcrumbDataFinance = useMemo(
    () => [
      {
        link: `/${routes.bom}/${routes.finance}`,
        name: `Activity Dashboard - ${communityDetail?.communityName}`,
      },
      {
        link: `/${routes.bom}/${routes.finance}/${routes.collection}`,
        name: "Collection",
      },
      {
        link: "",
        name: <span className="text-primary">Collection 360 Report</span>,
      },
    ],
    []
  );

  const breadcrumbDataDashboard = useMemo(
    () => [
      {
        link: `/${base}/${routes.dashboard}`,
        name: `Dashboard - ${communityDetail?.communityName}`,
      },
      {
        link: "",
        name: <span className="text-primary">Collection 360 Report</span>,
      },
    ],
    []
  );

  const breadcrumbData = fromDashboard
    ? breadcrumbDataDashboard
    : breadcrumbDataFinance;

  const onBackClick = () => {
    fromDashboard
      ? navigate(`/${base}/${routes.dashboard}`)
      : navigate(`/${routes.bom}/${routes.finance}/${routes.collection}`);
  };

  const togglePropertyView = () => {
    setIsPropertyView((prev) => !prev);
    // setDate(null);
  };

  return {
    breadcrumbData,
    isMobile,
    togglePropertyView,
    setDate,
    date,
    isPropertyView,
    onBackClick,
    currentRole,
    currentFinanceYear
  };
};

export default useAR360Report;
